const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const emailRegExp = /^[a-zA-ZäÄöÖüÜß0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-ZäÄöÖüÜß0-9-]{2,}(?:\.[a-zA-ZäÄöÖüÜß0-9-]+)+$/;
const usernameRegExp = /^[^@]*?$/; /*Kein "@"*/
const houseNoRegExp = /^[0-9]/;
const passwordRegExp = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}$/;
const urlSlugRegExp = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
// const passwordRegExp = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{6,}$/;

export {
    phoneRegExp,
    emailRegExp,
    usernameRegExp,
    houseNoRegExp,
    passwordRegExp,
    urlSlugRegExp,
}